module.exports = __webpack_public_path__ + "img/dukat.b064bfdf.png";